const asDate = value => {
    const date = new Date(value);
    if(!Number.isFinite(date.getTime())) {
        throw new TypeError('A valid current date is required');
    }
    return date;
};

export const createSystemAdvancedBillingTimeProvider = () => ({
    adjustable: false,
    now() {
        return new Date();
    },
});

export const createAdjustableAdvancedBillingTimeProvider = (
    initialDate = new Date()
) => {
    let currentDate = asDate(initialDate);
    const now = () => new Date(currentDate);

    return {
        adjustable: true,
        advance(seconds) {
            const elapsedSeconds = Number(seconds);
            if(Number.isFinite(elapsedSeconds)) {
                currentDate = new Date(
                    currentDate.getTime() + (elapsedSeconds * 1000)
                );
            }
            return now();
        },
        now,
        set(value) {
            currentDate = asDate(value);
            return now();
        },
    };
};

export const advancedBillingDemoTimeEnabled = () => (
    process.env.NODE_ENV !== 'production'
        && process.env.VUE_APP_ADVANCED_BILLING_DEMO_TIME === 'true'
);

export const createAdvancedBillingTimeProvider = () => (
    advancedBillingDemoTimeEnabled()
        ? createAdjustableAdvancedBillingTimeProvider()
        : createSystemAdvancedBillingTimeProvider()
);
